import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=8a15cb36&scoped=true"
import script from "./StatisticsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticsChart.vue?vue&type=style&index=0&id=8a15cb36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a15cb36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a15cb36')) {
      api.createRecord('8a15cb36', component.options)
    } else {
      api.reload('8a15cb36', component.options)
    }
    module.hot.accept("./StatisticsChart.vue?vue&type=template&id=8a15cb36&scoped=true", function () {
      api.rerender('8a15cb36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionStatistics/StatisticsChart.vue"
export default component.exports